var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('div',{staticClass:"message-box",class:'message-box_' + _vm.type},[_c('div',{staticClass:"message-box__icon"},[_c('IconMessageBoxAttention',{attrs:{"type":_vm.type}})],1),_c('p',{staticClass:"message-box__value",domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }